import axios from 'axios';

const API_BASE = '/api/company';

export interface SearchFilters {
  prefecture?: string;
  workStyle?: string;
  competitionPriority?: string;
  strength?: string;
  page?: number;
}

export interface SearchResult {
  profiles: any[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

export interface DashboardData {
  totalProfiles: number;
  totalScouts: number;
  unreadReplies: number;
  monthlyViews: number;
  planState: string;
}

export const companyService = {
  async searchProfiles(filters: SearchFilters): Promise<SearchResult> {
    const params = new URLSearchParams();
    if (filters.prefecture) params.set('prefecture', filters.prefecture);
    if (filters.workStyle) params.set('workStyle', filters.workStyle);
    if (filters.competitionPriority) params.set('competitionPriority', filters.competitionPriority);
    if (filters.strength) params.set('strength', filters.strength);
    if (filters.page) params.set('page', String(filters.page));

    const res = await axios.get(`${API_BASE}/search-profiles.php?${params.toString()}`);
    return res.data.data;
  },

  async viewProfile(uuid: string): Promise<any> {
    const res = await axios.get(`${API_BASE}/view-profile.php?uuid=${uuid}`);
    return res.data.data;
  },

  async getDashboard(): Promise<DashboardData> {
    const res = await axios.get(`${API_BASE}/dashboard.php`);
    return res.data.data;
  },
};
